import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  loadingWrapper: {
    width: '100%',
    minHeight: theme.spacing(10),
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

function Loading(): JSX.Element {
  const { classes } = useStyles();
  return (
    <div className={classes.loadingWrapper}>
      <CircularProgress color="inherit" />
    </div>
  );
}

export default Loading;
